export const types = {
    STATE_DRAW: 'state_draw',
    ADD_CLIPART_MODEL: 'add_clipart_model',
    SET_ACCORDION_ACTIVE_BUTTON: 'set_accordion_active_button',
    SET_MEDIA_FILES_DATA_PROVIDER: 'set_media_files_data_provider',
    CHANGE_ACCORDION_WIDTH: 'change_accordion_width',
    SET_ACTIVE_BUTTON: 'set_active_button',
    SET_OLD_ACTIVE_BUTTON: 'set_old_active_button'
};

export function setDrawState(state) {
    return { type: types.STATE_DRAW, state};
}

export function addClipartModel(clipartModel) {
    return { type: types.ADD_CLIPART_MODEL, clipartModel};
}

export function setAccordionActiveButton(buttonType) {
    return { type: types.SET_ACCORDION_ACTIVE_BUTTON, buttonType};
}

export function setMediaFilesDataProvider(dataProvider) {
    return { type: types.SET_MEDIA_FILES_DATA_PROVIDER, dataProvider};
}

export function changeAcoordionWidth(width) {
    return { type: types.CHANGE_ACCORDION_WIDTH, width};
}

export function setActiveButton(value, isCollapsed) {
    return { type: types.SET_ACTIVE_BUTTON, value, isCollapsed};
}

export function setOldActiveButton(value) {
    return { type: types.SET_OLD_ACTIVE_BUTTON, value};
}



/** WEBPACK FOOTER **
 ** ./src/actions/AccordionActions.js
 **/